<template>
    <b-card-group>
        <b-card no-body>
            <div class="card-body">
                <div>
                    <b-form class="filter-form">
                        <b-row>
                            <b-col cols="1">
                              <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                                <font-awesome-icon icon="times" />
                                {{ $t('Сброс') }}
                              </b-button>
                            </b-col>
                            <filter-date-between
                              :label="$t('Дата создания')"
                              v-on:onChange="search"
                              :cols="2"
                              v-model="createDateRange"
                              class="small-padding"
                            ></filter-date-between>
                            <filter-date-between
                              :label="$t('Дата отправки')"
                              v-on:onChange="search"
                              :cols="2"
                              v-model="sentDateRange"
                              class="small-padding"
                            ></filter-date-between>
                            <filter-input cols="2" 
                              :label="$t('Заголовок')" 
                              v-model="form.subject"
                              v-on:onBlur="search">
                            </filter-input>
                            <filter-select
                              :cols="1"
                              :label="$t('Статус')"
                              v-on:onChange="search"
                              v-model="form.status"
                              :options="statuses"
                              class="small-padding"
                            ></filter-select>
                            <filter-select
                              :cols="2"
                              :label="$t('Тип рассылки')"
                              v-on:onChange="search"
                              v-model="form.type"
                              :options="types"
                              class="small-padding"
                            ></filter-select>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </b-card>
    </b-card-group>
</template>

<script>
  import BaseFilter from "@/models/base.filter";

  export default {
    name: "filter-form",
    extends: BaseFilter,
    props: [
    'subject',
    'createDateFrom',
    'createDateTo',
    'sentDateFrom',
    'sentDateTo',
    'type',
    'status',
    ],
    data() {
      return {
        form: {
          subject: this.subject,
          createDateFrom: this.createDateFrom || null,
          createDateTo: this.createDateTo || null,
          sentDateFrom: this.sentDateFrom || null,
          sentDateTo: this.sentDateTo || null,
          type: this.type || null,
          status: this.status || null,
        },
        createDateRange: [],
        sentDateRange: [],
        types: [],
        statuses: [],
      };
    },
    mounted() {
      const createDateFrom = this.createDateFrom ? new Date(this.createDateFrom) : this.createDateFrom;
      const createDateTo = this.createDateTo ? new Date(this.createDateTo) : this.createDateTo;
      this.createDateRange = [createDateFrom, createDateTo];
      const sentDateFrom = this.sentDateFrom ? new Date(this.sentDateFrom) : this.sentDateFrom;
      const sentDateTo = this.sentDateTo ? new Date(this.sentDateTo) : this.sentDateTo;
      this.sentDateRange = [sentDateFrom, sentDateTo];
      this.statuses = [{ key: 1, value: 'Отправлено' }, { key: 2, value: 'Ожидает отправки' }];
      this.types = [{ key: 1, value: 'Моментальная отправка' }, { key: 2, value: 'Отправка в определенное время' }];
      this.applyDateRangeWatcher();
    },
    methods: {
      applyDateRangeWatcher() {
        this.$watch('createDateRange', function() {
          this.form.createdFrom = this.createDateRange[0] ? this.createDateRange[0].toJSON() : '';
          this.form.createdTo = this.createDateRange[1] ? this.createDateRange[1].toJSON() : '';
          this.search();
        });
        this.$watch('sentDateRange', function() {
          this.form.sentDateFrom = this.sentDateRange[0] ? this.sentDateRange[0].toJSON() : '';
          this.form.sentDateTo = this.sentDateRange[1] ? this.sentDateRange[1].toJSON() : '';
          this.search();
        });
      },
    }
  };
</script>
